import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React, { useEffect, useState } from 'react';
export default function CurrencySelect({
  value,
  onChange,
  ...props
}) {
  __useLocale();
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(false);
  useEffect(() => {
    const c = new AbortController();
    Promise.resolve().then(() => fetch('/api/commerce-config.php?kind=currencies', {
      signal: c.signal
    })).then(r => {
      if (!r.ok) throw Error();
      return r.json();
    }).then(r => {
      if (!Array.isArray(r)) throw Error();
      setRows(r);
    }).catch(() => {
      if (!c.signal.aborted) setError(true);
    });
    return () => c.abort();
  }, []);
  useEffect(() => {
    if (!value && rows.length) onChange({
      target: {
        value: (rows.find(r => Number(r.is_default)) || rows[0]).code
      }
    });
  }, [value, rows, onChange]);
  return <><select {...props} value={value || ''} onChange={onChange} className={props.className || 'block w-full border rounded-lg p-2'}><option value="">{__tr("اختر العملة")}</option>{__tr(value && !rows.some(c => c.code === value) && <option value={value}>{__tr(value)}</option>)}{__tr(rows.map(c => <option key={c.code} value={c.code}>{__tr(c.code)} — {__tr(__localizedField(c, "name"))}</option>))}</select>{__tr(error && <small className="text-red-700">{__tr("تعذر تحميل العملات")}</small>)}</>;
}
